import {
    PercentageOutlined
  } from "@ant-design/icons";
  import {
    Col,
    Form,
    Input,
    Select,
    Spin,
    Upload,
    message
  } from "antd";
  import "antd/dist/antd.min.css";
  import PropTypes from "prop-types";
  import React, { useEffect, useRef, useState } from "react";
  import { Trans, useTranslation } from "react-i18next";
  import {
    getRequest,
    patchRequest,
    postRequest
  } from "../../../axios";
  import ButtonField from "../../../common/htmlComponents/ButtonField";
  import InputField from "../../../common/htmlComponents/InputField";
  import { ReactComponent as About } from "../../../image/About.svg";
  import { ReactComponent as Name } from "../../../image/Name.svg";
  import "../../../styles/Main.scss";
  
  import {
    ErrorNotificationMsg,
    SuccessNotificationMsg,
  } from "../../../utils/Notifications";
import SubCategoryImageUpload from "./SubCategoryImageUpload";
  
  const AddSubCategory = ({
    handleCancel,
    zoneList,
    setReload,
    categoryTreeId,
    modalKey,
    setFileList,
    fileList,
    setStateM,
    categoryTree
  }) => {
    const { t } = useTranslation();
    const formRef = useRef();
  
    // State initialization
    const initialState = {
      category_tree: 1,
      name: null,
      description: null,
      gst_rate: null,
    };
    const [state, setState] = useState(initialState);
    const [btnLoading, setBtnLoading] = useState(false);
    const [apiLoading, setapiLoading] = useState(false);
    const [uploadFile, setUploadFile] = useState("");
    const [fileLink, setFileLink] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [size, setSize] = useState(null);
    const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
    const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  
    const [deleteFlag, setDeleteFlag] = useState(0);
  
    // Fetch category details by ID
    useEffect(() => {
      const categoryGetById = async () => {
  
        try {
          setapiLoading(true);
          const apiResponse = await getRequest(
            `sub-category/${categoryTreeId}/`
          );
          if (apiResponse.data.success) {
            setState(apiResponse.data.data);
            setFileLink(apiResponse.data.data.image);
            formRef.current.setFieldsValue({
              ...apiResponse.data.data,
            });
            const url = apiResponse.data.data.image;
            setIdentifyProfileUrl(apiResponse.data.data.image);
  
            if (url !== null) {
              setFileList([
                {
                  url: url,
                },
              ]);
            }
            setapiLoading(false);
          } else {
            ErrorNotificationMsg(t("error_in_list_category"));
          }
        } catch (error) {
          setapiLoading(false);
        }
      };
  
      if (categoryTreeId !== null) {
        categoryGetById();
      }
    }, [categoryTreeId, modalKey, setFileList, t]);
  
    // Handle Escape key to navigate back 
    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          backToList();
        }
      };
  
      window.addEventListener("keydown", handleKeyDown);
  
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, []);
  
    const url = state.image;
  
    let filename = "";
    try {
      if (fileLink) {
        filename = url.split("/").pop();
      }
    } catch (e) {
      filename = "";
    }
  
    // Handle input changes
    const handleInputChange = (e) => {
      let { name, value } = e.target;
      setState({ ...state, [name]: value });
    };
    const handleChange = (name, value) => {
      setState({ ...state, [name]: value });
    };
  
    // Validate file upload
    const beforeUpload = (file) => {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE;
      }
      // Clear error message if file type is correct
      return false; // Prevent automatic upload, will handle manually
    };
  
    // Upload props for the file
    const uploadProps = {
      accept: ".jpg, .png, .jpeg",
      showUploadList: false,
      beforeUpload: (file) => {
        setSize(file.size);
        if (file.size <= 2097152) {
          setUploadFile(file);
          setFileName(file.name);
        }
        return false;
      },
    };
  
    // Navigate back to the list
    const backToList = () => {
      setState(initialState);
      formRef.current.setFieldsValue(initialState);
      handleCancel();
    };
  
    // Handle form submission
    const handleSubmit = async () => {
      setBtnLoading(true);
  
      const payload = {
        category_tree: state.category_tree,
        name: state.name,
        description: state.description,
      };
      try {
        let apiResponse;
  
        let customerHeaders = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
  
        if (categoryTreeId === null) {
          apiResponse = await postRequest(
            "sub-category/", payload
          );
        } else {
          apiResponse = await patchRequest(
            `sub-category/${categoryTreeId}/`,payload
          );
        }
        if (apiResponse.data.success) {
          SuccessNotificationMsg(
            categoryTreeId === null
              ? t("sub_category_added_successfully")
              : t("sub_category_update_successfully")
          );
          setState(initialState);
          setDeleteFlag(0);
          setStateM((prev) => ({
            ...prev,
            page: 1,
          }));
          formRef.current.setFieldsValue(initialState);
          setBtnLoading(false);
          handleCancel();
          setReload((reload) => !reload);
        }
        setBtnLoading(false);
      } catch (error) {
        setBtnLoading(false);
      }
    };
    return (
      <>
        <section className="grid-sec FormSection Container">
          <div className="FormBody">
            <Spin spinning={apiLoading}>
              <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
              <Col md={24} className="TextFeild">
            <Form.Item
              name="category_tree"
              label={t("label_category")}
            >
              <Select
                showArrow
                showSearch
                allowClear
                // disabled
                defaultValue={1}
                placeholder="Select Caterory"
                optionFilterProp="children"
                onChange={(value) =>
                  setState({ ...state, category_tree: value })
                }
              >
                {categoryTree &&
                  categoryTree.length > 0 &&
                  categoryTree.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
                <Col md={24} className="TextFeild">
                  <InputField
                    name="name"
                    label={t("label_subcategory_name")}
                    rules={t("val_subcategory_name")}
                    placeholder={t("pl_subcategory_name")}
                    handleInputChange={handleInputChange}
                    prefix={<Name />}
                    pattern={"^[a-zA-Z0-9 ]+$"}
                    max={15}
                  />
                </Col>
                <Col md={24} className="TextFeild">
                  <InputField
                    name="description"
                    label={t("label_description")}
                    placeholder={t("pl_description")}
                    handleInputChange={handleInputChange}
                    prefix={<About />}
                    max={30}
                  />
                </Col>
  
  
                <div className="FormFooter">
                  <ButtonField
                    type="primary"
                    className="CancelGradiantBtn"
                    htmlType="button"
                    label={t("cancel")}
                    onClick={backToList}
                  />
  
                  <ButtonField
                    type="primary"
                    className="SaveGradiantBtn"
                    htmlType="Submit"
                    label={t("save")}
                    loading={btnLoading}
                  />
                </div>
              </Form>
            </Spin>
          </div>
        </section>
      </>
    );
  };
  AddSubCategory.propTypes = {
    handleCancel: PropTypes.func,
    zoneList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        zone_name: PropTypes.string,
      })
    ),
    setReload: PropTypes.func,
    categoryTreeId: PropTypes.number,
    modalKey: PropTypes.bool,
    fileList: PropTypes.array,
    setFileList: PropTypes.func,
    setStateM: PropTypes.func,
    categoryTree: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        })
      ),
  };
  
  export default AddSubCategory;
  